module.exports = __webpack_public_path__ + "images/kihnu/ms-icon-70x70.png";